import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editTab: true,
  hasEditPdc: null,
  editTabData: null,
  hasEditData: null,
  supplier_invoice_start_date: null,
  supplier_invoice_end_date: null,
  isError: {
    invoiceSummary_name: true,
    supplier_invoice_name: true,
    supplier_invoice_start_date: true
  },
  tableData: []
}

const invoiceSummary = createSlice({
  name: 'invoiceSummary_accounts',
  initialState,
  reducers: {
    brandSearch: (state, action) => {
      const { parent, key, value } = action.payload;
      state[parent][key] = value;
    },
    invoiceSummaryInput: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
      state[key].length === 0 ? state.isError[key] = true : state.isError[key] = false
    },
    getIsError: (state, action) => {
      const { key, value } = action.payload;
      state.isError[key] = value
    },
    setAutocomplete: (state, action) => {
      const { parent, key, value } =  action.payload;
      state[parent][key] = value
    },
    hasTabEdit: (state, action) => {
      const { editTab } =  action.payload;
      state.editTab = editTab
    },
    hasTabEditData: (state, action) => {
      const { editData } =  action.payload;
      state.editTabData = editData
    },
    setHasEditData: (state, action) => {
      state.hasEditData = action.payload;
    },
    setinvoiceSummaryFormStatus: (state, action) => {
      state.invoiceSummaryFormValid = action.payload;
    },
    resetinvoiceSummary: () => {
      return initialState
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
  }
})

export const { brandSearch, hasTabEditData, setAutocomplete, getIsError, invoiceSummaryInput, hasTabEdit, resetinvoiceSummary, setHasEditData, setinvoiceSummaryFormStatus, setTableData } = invoiceSummary.actions

export default invoiceSummary.reducer